import type { Icon } from '@/types/icons';

import * as iconLibrary from '../library';

export const professionSlugIcons: Record<string, Icon> = {
    alchemy: iconLibrary.gameFizzingFlask,
    blacksmithing: iconLibrary.gameAnvil,
    cooking: iconLibrary.gameBarbecue,
    enchanting: iconLibrary.gameSpellBook,
    engineering: iconLibrary.gamePokecog,
    fishing: iconLibrary.gamePiranha,
    herbalism: iconLibrary.gameTwirlyFlower,
    inscription: iconLibrary.gameScrollQuill,
    jewelcrafting: iconLibrary.gameEmerald,
    leatherworking: iconLibrary.gameHandBag,
    mining: iconLibrary.gameWarPick,
    skinning: iconLibrary.gameAnimalHide,
    tailoring: iconLibrary.gameRolledCloth,
};
